import React from "react";
import LoaderItemFeed from "./loader-item-feed";

const LoadingItem = ({ type }) => {
  if (type === "Feed") {
    return <LoaderItemFeed />;
  }

  return <div className="afd-story afd-story--loading" />;
};

export default LoadingItem;
